import * as React from "react";
import {AppTranslations} from "../../../../components/Utils/translations/AppTranslations";
import {VeBoxModal} from "../../../../components/modal/VeBoxModal";

import "./ErrorDialog.scss";
import {Display} from "../../../../components/Display";

declare var AppTranslations: AppTranslations;

interface ErrorDialogProps {
    onOk: () => void;
    description?: React.ReactElement;
}

export const ErrorDialog: React.FunctionComponent<ErrorDialogProps> = ({onOk, description}) => {
    return (
        <VeBoxModal>
            <VeBoxModal.Header
                title={AppTranslations.errorMessages.errorTitle}
                onClose={onOk}
            />
            <VeBoxModal.Section>
                <Display isVisible={description}>
                    {description}
                </Display>
                <Display isVisible={!description}>
                    <p>{AppTranslations.errorMessages.operationNotCurrentlyAvailable}</p>
                </Display>
            </VeBoxModal.Section>
        </VeBoxModal>
    );
};
